import { useState, useEffect } from 'react';

// PACKAGES
import { useHistory, useLocation } from 'react-router-dom';

export const useTabState = <T extends string>(defaultTab: T, paramName: string = 'tab'): [T, (tab: T) => void] => {
	const history = useHistory();
	const location = useLocation();
	const [activeTab, setActiveTab] = useState<T>(defaultTab);

	// Get current tab from URL params
	const searchParams = new URLSearchParams(location.search);
	const tabFromUrl = searchParams.get(paramName) as T;

	// Update tab state when URL changes
	useEffect(() => {
		if (tabFromUrl) {
			setActiveTab(tabFromUrl);
		}
	}, [tabFromUrl]);

	// Function to update both state and URL
	const updateTab = (tab: T) => {
		setActiveTab(tab);

		const newSearchParams = new URLSearchParams(location.search);
		newSearchParams.set(paramName, tab);

		history.push({
			pathname: location.pathname,
			search: newSearchParams.toString()
		});
	};

	return [activeTab, updateTab];
};
